import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useFocusedCommentSearchParams = () => {
  const [searchParams] = useSearchParams();
  const commentId = searchParams.get('comment_id');
  const replyId = searchParams.get('reply_id');

  return {
    commentId: Number(commentId) || undefined,
    replyId: Number(replyId) || undefined,
  };
};

export const useRemoveFocusedCommentsSearchParams = () => {
  const [, setSearchParams] = useSearchParams();

  return useCallback(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);

      newParams.delete('comment_id');
      newParams.delete('reply_id');

      return newParams;
    });
  }, [setSearchParams]);
};
